import Vue from 'vue'
import Router from 'vue-router'
import Vuetify from 'vuetify/lib'

import CommonRouterSection from '@/components/layout/CommonRouterSection'
import signinRouter from './modules/signin'
import signupRouter from './modules/signup'
import userRouter from './modules/user'
import informationRouter from './modules/information'
import applicationRouter from './modules/application'
import myapplicationRouter from './modules/myapplication'
import myrequestRouter from './modules/myrequest'
import modificationRouter from './modules/modification'
import maintenanceRouter from './modules/maintenance'
import appealRouter from './modules/appeal'
import oppositionRouter from './modules/opposition'
import paymentRouter from './modules/payment'
import publicserviceRouter from './modules/publicservice'
import verifycertifiedcopyRouter from './modules/verifycertifiedcopy'
import eserviceconversionRouter from './modules/eserviceconversion'
import portfolioRouter from './modules/portfolio'

import mainRouter from './modules/main'

import PerfectScrollbar from 'vue2-perfect-scrollbar'


import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'


Vue.use(Router)
Vue.use(Vuetify)
Vue.use(PerfectScrollbar,{
  options : {
    wheelPropagation : false
  }
})

export default new Router({  
  routes: [
    {
      path: '/',
      name: 'index',
      component: CommonRouterSection,
      redirect: '/main'
    },
    signinRouter,
    signupRouter,
    userRouter,
    informationRouter,
    applicationRouter,
    myrequestRouter,
    myapplicationRouter,
    modificationRouter,
    maintenanceRouter,
    appealRouter,
    oppositionRouter,
    mainRouter,
    paymentRouter,
    publicserviceRouter,
    verifycertifiedcopyRouter,
    eserviceconversionRouter,
    portfolioRouter    
  ]
})
